import { render } from "./ScriptConfig.vue?vue&type=template&id=63ee2984&scoped=true"
import script from "./ScriptConfig.vue?vue&type=script&lang=js"
export * from "./ScriptConfig.vue?vue&type=script&lang=js"

import "./ScriptConfig.vue?vue&type=style&index=0&id=63ee2984&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63ee2984"]])

export default __exports__